// Lê o usuário logado do localStorage com segurança. Se o valor estiver
// corrompido (não-JSON), retorna null em vez de derrubar a tela inteira.
export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
}
